   //Navbar dropdown
//______________________________________________
document.addEventListener("DOMContentLoaded", function () {

  const shopToggle = document.getElementById("shopToggle");
  const shopMenu = document.getElementById("shopMenu");

  if (shopToggle && shopMenu) {

shopToggle.addEventListener("click", function () {

  const isOpening = shopMenu.classList.contains("max-h-0");

  if (isOpening) {
    shopMenu.classList.remove("max-h-0", "opacity-0", "overflow-hidden", "pointer-events-none");
    shopMenu.classList.add("max-h-[500px]", "opacity-100", "overflow-visible", "pointer-events-auto");

    // 🔥 AUTO OPEN FIRST ITEM
    setTimeout(() => {

      const firstToggle = shopMenu.querySelector(".mega-toggle");
      const firstDropdown = shopMenu.querySelector(".mega-dropdown");

      if (!firstToggle || !firstDropdown) return;

      // Reset ALL dropdowns
      shopMenu.querySelectorAll(".mega-dropdown").forEach(menu => {
        menu.classList.remove("opacity-100", "visible", "scale-100", "translate-y-0");
        menu.classList.add("opacity-0", "invisible", "scale-95", "translate-y-4");
      });

      // Reset ALL toggles
      shopMenu.querySelectorAll(".mega-toggle").forEach(btn => {
        btn.classList.remove("active");
      });

      // Activate FIRST
      firstToggle.classList.add("active");

      firstDropdown.classList.remove("opacity-0", "invisible", "scale-95", "translate-y-4");
      firstDropdown.classList.add("opacity-100", "visible", "scale-100", "translate-y-0");

    }, 50); // 🔥 needed for DOM render timing

  } else {
    shopMenu.classList.remove("max-h-[500px]", "opacity-100", "overflow-visible", "pointer-events-auto");
    shopMenu.classList.add("max-h-0", "opacity-0", "overflow-hidden", "pointer-events-none");

    // Reset everything on close
    shopMenu.querySelectorAll(".mega-toggle").forEach(btn => {
      btn.classList.remove("active");
    });

    shopMenu.querySelectorAll(".mega-dropdown").forEach(menu => {
      menu.classList.remove("opacity-100", "visible", "scale-100", "translate-y-0");
      menu.classList.add("opacity-0", "invisible", "scale-95", "translate-y-4");
    });
  }

});

  }

});

//Mega menu js
//-----------------------------
document.addEventListener("DOMContentLoaded", function () {

  const toggles = document.querySelectorAll(".mega-toggle");

  if (!toggles.length) return;

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const target = this;
      const parent = target.closest(".mega-menu-container");
      if (!parent) return;

      const dropdown = parent.querySelector(".mega-dropdown");
      if (!dropdown) return;

      const isOpen = dropdown.classList.contains("opacity-100");

      // Close all other dropdowns first
      document.querySelectorAll(".mega-dropdown").forEach(menu => {
        if (menu !== dropdown) {
          menu.classList.remove("opacity-100", "visible", "scale-100", "translate-y-0");
          menu.classList.add("opacity-0", "invisible", "scale-95", "translate-y-4");
        }
      });

      // Remove active from all other toggles
      toggles.forEach(btn => {
        if (btn !== target) btn.classList.remove("active");
      });

      // Toggle current
      if (isOpen) {
        dropdown.classList.remove("opacity-100", "visible", "scale-100", "translate-y-0");
        dropdown.classList.add("opacity-0", "invisible", "scale-95", "translate-y-4");
        target.classList.remove("active");
      } else {
        dropdown.classList.remove("opacity-0", "invisible", "scale-95", "translate-y-4");
        dropdown.classList.add("opacity-100", "visible", "scale-100", "translate-y-0");
        target.classList.add("active");
      }
    });
  });

  // Close when clicking outside
    document.addEventListener("click", function (e) {
      const clickTarget = e.target;
      if (!(clickTarget instanceof Element)) return;

      const isInsideShopMenu = clickTarget.closest("#shopMenu");
      const isShopToggle    = clickTarget.closest("#shopToggle");

      if (!isInsideShopMenu && !isShopToggle) {
        // Click is fully outside — close dropdowns AND the sub-navbar
        document.querySelectorAll(".mega-dropdown").forEach(menu => {
          menu.classList.remove("opacity-100", "visible", "scale-100", "translate-y-0");
          menu.classList.add("opacity-0", "invisible", "scale-95", "translate-y-4");
        });

        toggles.forEach(btn => btn.classList.remove("active"));

        // Also collapse the shopMenu sub-navbar itself
        const shopMenu = document.getElementById("shopMenu");
        if (shopMenu && !shopMenu.classList.contains("max-h-0")) {
          shopMenu.classList.remove("max-h-[500px]", "opacity-100", "overflow-visible", "pointer-events-auto");
          shopMenu.classList.add("max-h-0", "opacity-0", "overflow-hidden", "pointer-events-none");
        }

      } else if (isInsideShopMenu && !clickTarget.closest(".mega-menu-container")) {
        // Click is inside the sub-navbar but NOT on a category tab — close image cards only
        document.querySelectorAll(".mega-dropdown").forEach(menu => {
          menu.classList.remove("opacity-100", "visible", "scale-100", "translate-y-0");
          menu.classList.add("opacity-0", "invisible", "scale-95", "translate-y-4");
        });

        toggles.forEach(btn => btn.classList.remove("active"));
      }
    });

});

//Navbar Sticky logic
//-------------------------
document.addEventListener("DOMContentLoaded", function () {

  const announcement = document.getElementById("announcementBar");
  const stickyGroup  = document.getElementById("stickyHeaderGroup");

  let lastScrollY      = window.scrollY;
  let accumulatedDelta = 0;
  let rafId            = null;

  const SCROLL_THRESHOLD  = 6;   // minimum px change to count as intentional scroll
  const HIDE_AFTER        = 80;  // px from top before hide-on-down activates
  const DOWN_DELTA_NEEDED = 60;  // total px scrolled down before hiding navbar
  const UP_DELTA_NEEDED   = 10;  // total px scrolled up before showing navbar

  function updateNavbar() {
    rafId = null;

    const currentScrollY = window.scrollY;
    const delta          = currentScrollY - lastScrollY;

    // Ignore tiny jitter (mobile bounce / inertia noise)
    if (Math.abs(delta) < SCROLL_THRESHOLD) return;

    // Announcement bar + sticky class
    if (currentScrollY > 50) {
      if (announcement) announcement.classList.add("hide-announcement");
      if (stickyGroup)  stickyGroup.classList.add("sticky-header");
    } else {
      if (announcement) announcement.classList.remove("hide-announcement");
      if (stickyGroup)  stickyGroup.classList.remove("sticky-header");
      // At the very top always show navbar
      if (stickyGroup)  stickyGroup.classList.remove("navbar-hidden");
      accumulatedDelta = 0;
      lastScrollY      = currentScrollY;
      return;
    }

    // Accumulate intentional direction
    accumulatedDelta += delta;

    if (stickyGroup) {
      if (accumulatedDelta > DOWN_DELTA_NEEDED && currentScrollY > HIDE_AFTER) {
        // Scrolled down enough — hide
        stickyGroup.classList.add("navbar-hidden");
        accumulatedDelta = 0;
      } else if (accumulatedDelta < -UP_DELTA_NEEDED) {
        // Scrolled up enough — show
        stickyGroup.classList.remove("navbar-hidden");
        accumulatedDelta = 0;
      }
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener("scroll", function () {
    if (rafId) return;
    rafId = requestAnimationFrame(updateNavbar);
  }, { passive: true });

});



//Trending social card popup js
//-------------------------------------
document.addEventListener("DOMContentLoaded", function() {

  const slides = document.querySelectorAll(".trending-swiper .swiper-slide");
  const popup = document.getElementById("videoPopup");
  const popupVideo = document.getElementById("popupVideo");
  const popupClose = document.getElementById("popupClose");
  const popupRightPanel = document.getElementById("popupRightPanel");

  if (!popup || !slides.length) return;

  slides.forEach(slide => {
    slide.addEventListener("click", function() {

      popup.classList.remove("opacity-0", "invisible");
      popup.classList.add("opacity-100", "visible");
      document.body.classList.add("overflow-hidden");

      if (this.dataset.videoSrc && popupVideo) {
        popupVideo.src = this.dataset.videoSrc;
      }

      const template = this.querySelector(".popup-template");
        if (template && popupRightPanel) {
          popupRightPanel.innerHTML = template.innerHTML;

          // Re-bind Add to Cart after clone
          popupRightPanel.querySelectorAll('.popupAddToCart').forEach(btn => {
            btn.addEventListener('click', () => {
              addToCartAndUpdate(btn.dataset.variantId);
            });
          });
        }
    });
  });

  if (popupClose) {
    popupClose.addEventListener("click", function() {
      popup.classList.remove("opacity-100", "visible");
      popup.classList.add("opacity-0", "invisible");
      document.body.classList.remove("overflow-hidden");
      if (popupVideo) {
        popupVideo.pause();
        popupVideo.src = '';
      }
    });
  }

  // Handle video popup close on backdrop click
  popup.addEventListener("click", function(e) {
    if (e.target === popup) {
      popup.classList.remove("opacity-100", "visible");
      popup.classList.add("opacity-0", "invisible");
      document.body.classList.remove("overflow-hidden");
      if (popupVideo) {
        popupVideo.pause();
        popupVideo.src = '';
      }
    }
  });

});



document.addEventListener('DOMContentLoaded', function () {

  const trendingSections = document.querySelectorAll('.trending-swiper');

  trendingSections.forEach((swiperEl) => {

    const progressBar = swiperEl
      .closest('section')
      .querySelector('.trending-progress-bar');

    if (!swiperEl) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
   const progressContainer = progressBar.parentElement;
    const getOffset = () => {
      const section = swiperEl.closest('section');
      if (!section) return 0;

      const container = section.querySelector('.custom-container');
      if (!container) return 0;

      const rect = container.getBoundingClientRect();
      const style = window.getComputedStyle(container);

      return rect.left + (parseFloat(style.paddingLeft) || 0);
    };

    const trendingSwiper=new Swiper(swiperEl, {
      slidesPerView: 4,
      spaceBetween: 16,
      grabCursor: true,
      slidesOffsetBefore: getOffset(),
      slidesOffsetAfter: getOffset(),
      breakpoints: {
        320: {
          spaceBetween: 16,
          slidesPerView: 1.2
        },
        1024: {
          spaceBetween: 16,
          slidesPerView: 5
         },
         1440: {
          slidesPerView: 6.5
         }
      },
      on: {
        progress: function (swiper) {
          if (progressBar) {
            progressBar.style.width =
              (Math.max(0, Math.min(1, swiper.progress)) * 100) + '%';
          }
        }
      }
    });
   // ✅ CLICK TO SLIDE
    progressContainer.addEventListener('click', function (e) {

        const rect = progressContainer.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const width = rect.width;

        const percentage = clickX / width;

        const maxIndex = trendingSwiper.slides.length - 1;

      trendingSwiper.slideTo(Math.floor(percentage * maxIndex));

    });

  });




  // ---------------------------------------------------------
// Bestsellers Swiper (Shopify Section Compatible)
// ---------------------------------------------------------

document.querySelectorAll('[id^="bestsellers-swiper-"]').forEach((swiperEl) => {

    const section = swiperEl.closest('section');
    if (!section) return;

    const progressBar = section.querySelector('[id^="bestsellers-progress-bar-"]');
    if (!progressBar) return;

    const progressContainer = progressBar.parentElement; 

    const getOffset = () => {
    // Use custom-container's left margin instead of .container padding
    const container = section.querySelector('.custom-container');
    if (!container) {
      // Fallback: calculate from CSS variable directly
      const gutter = parseFloat(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--container-gutter')
      ) || 20;
      return gutter;
    }
    return container.getBoundingClientRect().left;
  };

    // ✅ Store swiper in variable
    const bestsellersSwiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 16,
        grabCursor: true,
        slidesOffsetBefore: getOffset(),
        slidesOffsetAfter: getOffset(),
        breakpoints: {
            320: { slidesPerView: 1.2, spaceBetween: 16 },
            1024: { slidesPerView: "auto", spaceBetween: 24 },
        },

        on: {
            progress: function (swiper) {
                const clamped = Math.max(0, Math.min(1, swiper.progress));
                progressBar.style.width = (clamped * 100) + '%';
            },

            resize: function (swiper) {
            const offset = getOffset();
            swiper.params.slidesOffsetBefore = offset;
            swiper.params.slidesOffsetAfter = offset;
            swiper.update();
          }
        }
    });

    // ✅ Click to slide
    progressContainer.addEventListener('click', function (e) {

        const rect = progressContainer.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const width = rect.width;

        const percentage = clickX / width;

        const maxIndex = bestsellersSwiper.slides.length - 1;

        bestsellersSwiper.slideTo(Math.floor(percentage * maxIndex));

    });

});



       // ---------------------------------------------------------
    // 18. Card Section Swiper (Shop by Function and Category)
    // ---------------------------------------------------------
    const cardSwiperElement = document.querySelector('#card-swiper-container');
    const cardProgressBar = document.getElementById('card-progress-bar');
 const progressContainer = cardProgressBar?.parentElement;

    if (cardSwiperElement) {
        const getCardSectionOffset = () => {
            const section = cardSwiperElement.closest('section');
            if (!section) return 20;
            const container = section.querySelector('.custom-container');
            if (container) {
                const style = window.getComputedStyle(container);
                const paddingLeft = parseFloat(style.paddingLeft) || 0;
                const rect = container.getBoundingClientRect();
                return rect.left + paddingLeft;
            }
            return 20;
        };

        const cardSwiper = new Swiper("#card-swiper-container", {
            slidesPerView: 3.3,
            spaceBetween: 12,
            scrollbar: {
              el: '#card-swiper-scrollbar',
              draggable: true,
              snapOnRelease: true,
            },
            grabCursor: true,
            watchSlidesProgress: true,
            slidesOffsetBefore: getCardSectionOffset(),
            slidesOffsetAfter: getCardSectionOffset(),
            breakpoints: {
                1024: {
                    slidesPerView: 3.3,
                    spaceBetween: 12,
                    slidesOffsetBefore: getCardSectionOffset(),
                }
            },
            on: {
                progress: function (swiper) {
                    if (cardProgressBar) {
                        const progress = swiper.progress;
                        const clampedProgress = Math.max(0, Math.min(1, progress));
                        cardProgressBar.style.width = (clampedProgress * 100) + '%';
                    }
                },
                resize: function (swiper) {
                    const offset = getCardSectionOffset();
                    swiper.params.slidesOffsetBefore = offset;
                    swiper.params.slidesOffsetAfter = offset;
                    swiper.update();
                },
                init: function (swiper) {
                    setTimeout(() => {
                        swiper.params.slidesOffsetBefore = getCardSectionOffset();
                        swiper.update();
                    }, 100);
                }
            }
        });

            // ✅ Click to slide
    progressContainer.addEventListener('click', function (e) {

        const rect = progressContainer.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const width = rect.width;

        const percentage = clickX / width;

        const maxIndex = cardSwiper.slides.length - 1;

        cardSwiper.slideTo(Math.floor(percentage * maxIndex));

    });
    }


      // ---------------------------------------------------------
    // 6. Limited Time Deals Swiper + Progress Bar
    // ---------------------------------------------------------
 const dealsSwiperElement = document.querySelector('#deals-swiper');
const dealsProgressBar = document.getElementById('deals-progress-bar');

if (dealsSwiperElement && dealsProgressBar) {

    const progressContainer = dealsProgressBar.parentElement; // ✅ white outer bar

    const getCardSectionOffset = () => {
            const section = dealsSwiperElement.closest('section');
            if (!section) return 20;
            const container = section.querySelector('.custom-container');
            if (container) {
                const style = window.getComputedStyle(container);
                const paddingLeft = parseFloat(style.paddingLeft) || 0;
                const rect = container.getBoundingClientRect();
                return rect.left + paddingLeft;
            }
            return 20;
        };

    const dealsSwiper = new Swiper("#deals-swiper", {
        grabCursor: true,
        watchOverflow: true,
        slidesOffsetBefore: getCardSectionOffset(),
        slidesOffsetAfter: getCardSectionOffset(),
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            480: {
                slidesPerView: 1.5,
                spaceBetween: 18,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 18,
            }
        },

        on: {
            progress: function (swiper) {
                const clampedProgress = Math.max(0, Math.min(1, swiper.progress));
                dealsProgressBar.style.width = `${clampedProgress * 100}%`;
            },
            resize: function (swiper) {
                    const offset = getCardSectionOffset();
                    swiper.params.slidesOffsetBefore = offset;
                    swiper.params.slidesOffsetAfter = offset;
                    swiper.update();
                },
        }
    });

    // ✅ CLICK TO SLIDE
    progressContainer.addEventListener('click', function (e) {

        const rect = progressContainer.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const width = rect.width;

        const percentage = clickX / width;

        const maxIndex = dealsSwiper.slides.length - 1;

        dealsSwiper.slideTo(Math.floor(percentage * maxIndex));

    });
}



      // ---------------------------------------------------------
    // 2. Combo Tabs Logic (Swiper + Tab Filtering)
    // ---------------------------------------------------------
    const comboTabButtons = document.querySelectorAll('.combo-tab-btn');
    const comboCards = document.querySelectorAll('.combo-card');
    const combosSwiperElement = document.querySelector('#combos-swiper');

    const getOffset = () => {
      const container = combosSwiperElement
        .closest('section')
        ?.querySelector('.custom-container');
      
      if (container) {
        return container.getBoundingClientRect().left;
      }
      
      return parseFloat(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--container-gutter')
      ) || 20;
    };
    if (combosSwiperElement && comboTabButtons.length > 0 && comboCards.length > 0) {
        // Initialize Swiper
        const combosSwiper = new Swiper("#combos-swiper", {
            slidesPerView: 4.5,    
            spaceBetween: 16,
            slidesOffsetBefore: getOffset(),
            slidesOffsetAfter: getOffset(),
            initialSlide: 1,
            // IMPORTANT
            loop: false,
            grabCursor: true,
            navigation: {
                nextEl: "#combos-scroll-right",
                prevEl: "#combos-scroll-left",
            },

            // ✅ RESPONSIVE BREAKPOINTS
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,

                    initialSlide: 1,
                },
                1280: {
                    slidesPerView: 4.5,
                    spaceBetween: 16,

                    initialSlide: 1,
                },

            },
            on: {
              resize : function (swiper) {
                const offset = getOffset();
                swiper.params.slidesOffsetBefore = offset;
                swiper.params.slidesOffsetAfter = offset;
                swiper.update();
              }
          }
        });

        // --- Helper: Update Tab Styling ---
        const updateComboTabStyle = (activeCategory) => {
            comboTabButtons.forEach(btn => {
                if (btn.dataset.category === activeCategory) {
                    btn.classList.add('border-white', 'text-white');
                    btn.classList.remove('text-white/70', 'border-transparent');
                } else {
                    btn.classList.remove('border-white', 'text-white');
                    btn.classList.add('text-white/70', 'border-transparent');
                }
            });
        };

        // --- Helper: Filter Cards ---
        const filterComboCards = (category) => {
            comboCards.forEach(card => {
                card.style.display =
                    card.dataset.category === category ? 'flex' : 'none';
            });

            // 🔁 Update Swiper after DOM changes
            combosSwiper.update();
            combosSwiper.slideTo(0, 0);
        };

        // --- Tab Click Event ---
        comboTabButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const category = btn.dataset.category;
                updateComboTabStyle(category);
                filterComboCards(category);
            });
        });

        // --- Initial State ---
        const initialCategory = comboTabButtons[0].dataset.category || 'Combo 1';
        updateComboTabStyle(initialCategory);
        filterComboCards(initialCategory);
    }

   // ---------------------------------------------------------
    // 13. Blog Pagination Logic
    // ---------------------------------------------------------
    const blogCards = document.querySelectorAll('.blog-card');
    const blogPrevBtn = document.getElementById('prevPage');
    const blogNextBtn = document.getElementById('nextPage');
    const blogPageNumbers = document.getElementById('pageNumbers');

    if (blogCards.length > 0 && blogPrevBtn && blogNextBtn && blogPageNumbers) {
        let currentPage = 1;
        const itemsPerPage = 6; // Standard for blogs grid (3 columns)

        const updateBlogPagination = () => {
            const totalItems = blogCards.length;
            const totalPages = Math.ceil(totalItems / itemsPerPage);

            // Validate page
            if (currentPage < 1) currentPage = 1;
            if (currentPage > totalPages) currentPage = totalPages;

            // Show/Hide cards
            blogCards.forEach((card, index) => {
                const start = (currentPage - 1) * itemsPerPage;
                const end = start + itemsPerPage;

                if (index >= start && index < end) {
                    card.style.display = 'flex';
                } else {
                    card.style.display = 'none';
                }
            });

            // Update Page Numbers
            blogPageNumbers.innerHTML = '';
            for (let i = 1; i <= totalPages; i++) {
                const span = document.createElement('span');
                const isActive = i === currentPage;

                span.className = `w-8 h-8 flex items-center justify-center rounded-full cursor-pointer transition-all ${isActive
                    ? 'bg-black text-white'
                    : 'border border-[#E5E5E5] text-[#1D1D1F] hover:bg-gray-100'
                    }`;

                span.textContent = i;
                span.addEventListener('click', () => {
                    currentPage = i;
                    updateBlogPagination();
                });
                blogPageNumbers.appendChild(span);
            }

            // Update Buttons
            blogPrevBtn.disabled = currentPage === 1;
            blogNextBtn.disabled = currentPage === totalPages || totalPages === 0;

            blogPrevBtn.style.opacity = blogPrevBtn.disabled ? '0.5' : '1';
            blogNextBtn.style.opacity = blogNextBtn.disabled ? '0.5' : '1';
        };

        // Event Listeners
        blogPrevBtn.addEventListener('click', () => {
            if (currentPage > 1) {
                currentPage--;
                updateBlogPagination();
            }
        });

        blogNextBtn.addEventListener('click', () => {
            const totalPages = Math.ceil(blogCards.length / itemsPerPage);
            if (currentPage < totalPages) {
                currentPage++;
                updateBlogPagination();
            }
        });

        // Initialize
        updateBlogPagination();
    }

   // ---------------------------------------------------------
// Pressure Washers Swiper
// ---------------------------------------------------------

document.querySelectorAll('[id^="washers-swiper-"]').forEach((swiperEl) => {

  const section = swiperEl.closest('section');
  if (!section) return;

  const progressBar = section.querySelector('[id^="washers-progress-bar-"]');
  if (!progressBar) return;

  const progressContainer = progressBar.parentElement; // ✅ define this

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  const washersSwiper = new Swiper(swiperEl, {
    slidesPerView: 3,
    spaceBetween: 28,
    grabCursor: true,

    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      640: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 28
      }
    },

    on: {
      progress: function (swiper) {
        const progress = swiper.progress;
        const clampedProgress = Math.max(0, Math.min(1, progress));
        progressBar.style.width = (clampedProgress * 100) + '%';
      }
    }
  });

  // ✅ event listener should be OUTSIDE swiper config
  progressContainer.addEventListener('click', function (e) {

    const rect = progressContainer.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const width = rect.width;

    const percentage = clickX / width;

    washersSwiper.slideTo(
      Math.floor(
        percentage *
        (washersSwiper.slides.length - washersSwiper.params.slidesPerView)
      )
    );
  });

});



// ---------------------------------------------------------
// 3. Add-Ons Logic (Shopify Safe Version)
 // ---------------------------------------------------------

   document.querySelectorAll('[id^="add-ons-swiper-"]').forEach((swiperEl) => {

  const section = swiperEl.closest('section');
  if (!section) return;

  const sectionId = swiperEl.id.replace('add-ons-swiper-', '');

  const addonTabButtons = section.querySelectorAll('.addon-tab-btn');
  const addonCards = section.querySelectorAll('.addon-card');
  const prevBtn = section.querySelector(`#add-ons-scroll-left-${sectionId}`);
  const nextBtn = section.querySelector(`#add-ons-scroll-right-${sectionId}`);

  if (!swiperEl || addonTabButtons.length === 0 || addonCards.length === 0)
    return;

  const addonSwiper = new Swiper(swiperEl, {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: false,
    grabCursor: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 16 },
      480: { slidesPerView: 1.8, spaceBetween: 16 },
      640: { slidesPerView: 2, spaceBetween: 20 },
      768: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 24 },
      1280: { slidesPerView: 4.5, spaceBetween: 20 },
    },
  });

  // --- Update Tab Styling ---
  const updateAddonTabStyle = (activeCategory) => {
  addonTabButtons.forEach(btn => {

    // Always reset first
    btn.classList.remove('border-b-2');
    btn.style.borderColor = 'transparent';
    btn.classList.remove('text-[#ea0029]');
    btn.classList.add('text-[#000]');

    // Active one
    if (btn.dataset.category === activeCategory) {
      btn.classList.add('border-b-2');
      btn.style.borderColor = '#ea0029';
      btn.classList.remove('text-[#000]');
      btn.classList.add('text-[#ea0029]');
    }

  });
  };


  // --- Filter Cards ---
  const filterAddonCards = (category) => {
    addonCards.forEach(card => {
      card.style.display =
        card.dataset.category === category ? 'flex' : 'none';
    });

    addonSwiper.update();
    addonSwiper.slideTo(0, 0);
  };

  // --- Tab Click ---
  addonTabButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const category = btn.dataset.category;
      updateAddonTabStyle(category);
      filterAddonCards(category);
    });
  });

  // --- Initial State ---
  const initialCategory = addonTabButtons[0]?.dataset.category;
  if (initialCategory) {
    updateAddonTabStyle(initialCategory);
    filterAddonCards(initialCategory);
  }

 });


document.addEventListener("DOMContentLoaded", function () {

  // Desktop button
  const viewAllBtn = document.getElementById("view-all-deals");

  // Mobile button
  const viewAllBtnMobile = document.getElementById("view-all-deals-mobile");

  // All hidden products
  const hiddenProducts = document.querySelectorAll(".extra-product");

  // Function to show all products
  const showAllProducts = () => {

    hiddenProducts.forEach(product => {
      product.classList.remove("hidden");
    });

    // Hide both buttons after click
    if (viewAllBtn) {
      viewAllBtn.style.display = "none";
    }

    if (viewAllBtnMobile) {
      viewAllBtnMobile.style.display = "none";
    }
  };

  // Desktop click
  if (viewAllBtn) {
    viewAllBtn.addEventListener("click", function (e) {
      e.preventDefault();
      showAllProducts();
    });
  }

  // Mobile click
  if (viewAllBtnMobile) {
    viewAllBtnMobile.addEventListener("click", function (e) {
      e.preventDefault();
      showAllProducts();
    });
  }

});



 // ---------------------------------------------------------
    // 16. FAQ Tab Switching Logic
    // ---------------------------------------------------------
    const faqTabButtons = document.querySelectorAll('.faq-tab-btn');
    const faqContentPanes = document.querySelectorAll('.faq-content-pane');

    if (faqTabButtons.length > 0 && faqContentPanes.length > 0) {
        faqTabButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const targetId = btn.getAttribute('data-target');

                // Update Button Styles
                faqTabButtons.forEach(b => {
                    b.classList.remove('text-[#EA0029]', 'border-[#EA0029]');
                    b.classList.add('text-[#7F7F7F]', 'border-transparent');
                });
                btn.classList.add('text-[#EA0029]', 'border-[#EA0029]');
                btn.classList.remove('text-[#7F7F7F]', 'border-transparent');

                // Show/Hide Content Panes
                faqContentPanes.forEach(pane => {
                    if (pane.id === targetId) {
                        pane.classList.remove('hidden');
                    } else {
                        pane.classList.add('hidden');
                    }
                });
            });
        });
    }


    // ---------------------------------------------------------
    // 17. Special Offer Auto-run logic
    // ---------------------------------------------------------
    // const offerCards = document.querySelectorAll('.offer-card');
    // const offerFills = document.querySelectorAll('.offer-progress-fill');
    // let currentOfferIndex = 0;
    // const offerDuration = 6000; // 6 seconds per offer
    // let offerInterval;
    // let startTime;
    // let animationFrame;

    // if (offerCards.length > 0 && offerFills.length > 0) {
    //     const updateOffer = (index) => {
    //         offerCards.forEach((card, i) => {
    //             if (i === index) {
    //                 card.classList.remove('hidden');
    //                 card.classList.add('flex');
    //             } else {
    //                 card.classList.add('hidden');
    //                 card.classList.remove('flex');
    //             }
    //         });
    //     };

    //     const animateProgress = (timestamp) => {
    //         if (!startTime) startTime = timestamp;
    //         const elapsed = timestamp - startTime;
    //         const progress = Math.min(elapsed / offerDuration, 1);

    //         // Clear all fills first if we just started a new index
    //         offerFills.forEach((fill, i) => {
    //             if (i < currentOfferIndex) {
    //                 fill.style.width = '100%';
    //             } else if (i === currentOfferIndex) {
    //                 fill.style.width = `${progress * 100}%`;
    //             } else {
    //                 fill.style.width = '0%';
    //             }
    //         });

    //         if (progress < 1) {
    //             animationFrame = requestAnimationFrame(animateProgress);
    //         } else {
    //             // Time's up! Switch to next
    //             currentOfferIndex = (currentOfferIndex + 1) % offerCards.length;

    //             // If we wrap around, reset all fills
    //             if (currentOfferIndex === 0) {
    //                 offerFills.forEach(fill => fill.style.width = '0%');
    //             }

    //             startTime = null;
    //             updateOffer(currentOfferIndex);
    //             animationFrame = requestAnimationFrame(animateProgress);
    //         }
    //     };

    //     // Start the cycle
    //     updateOffer(currentOfferIndex);
    //     animationFrame = requestAnimationFrame(animateProgress);
    // }

  });
document.addEventListener("DOMContentLoaded", function () {

  const swiperElement = document.querySelector("#may-swiper");
  const progressBar = document.querySelector("#may-progress-bar");

  if (!swiperElement || !progressBar) return;

  const progressContainer = progressBar.parentElement;

  const maySwiper = new Swiper("#may-swiper", {
    slidesPerView: 3,
    spaceBetween: 28,
    grabCursor: true,
    watchOverflow: true,

    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16
      },
      480: {
        slidesPerView: 1.8,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 28
      }
    },

    on: {
      init: function (swiper) {
        updateProgress(swiper);
      },
      slideChange: function (swiper) {
        updateProgress(swiper);
      },
      progress: function (swiper) {
        updateProgress(swiper);
      },
      resize: function (swiper) {
        swiper.update();
        updateProgress(swiper);
      }
    }
  });

  function updateProgress(swiper) {
    const progress = Math.max(0, Math.min(1, swiper.progress));
    progressBar.style.width = (progress * 100) + "%";
  }

  // ✅ Clickable Progress Bar
  progressContainer.addEventListener('click', function (e) {

    const rect = progressContainer.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const percentage = clickX / rect.width;

    const totalSlides = maySwiper.slides.length;
    const visibleSlides = maySwiper.params.slidesPerView;

    const slideIndex = Math.floor(
      percentage * (totalSlides - visibleSlides)
    );

    maySwiper.slideTo(slideIndex);
  });

});


/*
  Product Image Gallery Logic
  ----------------------------

*/

document.addEventListener("DOMContentLoaded", function () {
  const productThumbSlider = document.querySelector(".product-thumb-slider");
  const productMainSlider = document.querySelector(".product-main-slider");

  /*
    This file loads on every template. Stop here unless the current
    page actually contains the custom product gallery.
  */
  if (
    !productThumbSlider ||
    !productMainSlider ||
    typeof window.Swiper !== "function"
  ) {
    return;
  }

  const thumbSwiper = new Swiper(productThumbSlider, {
    spaceBetween: 12,
    slidesPerView: "auto",   // 🔥 important for swipe
    freeMode: true,          // 🔥 enables smooth swipe
    watchSlidesProgress: true,
    grabCursor: true,
    slideToClickedSlide: true,
    resistanceRatio: 0.85,
  });

  const mainSwiper = new Swiper(productMainSlider, {
    spaceBetween: 10,
    slidesPerView: 1,
    grabCursor: true,
    thumbs: {
      swiper: thumbSwiper,
    },
    on: {
      slideChange: function () {
        thumbSwiper.slideTo(this.activeIndex);
      }
    }
  });

  // Lightbox Script

// ── LIGHTBOX SETUP ──────────────────────────────────────────
const lightboxEl = document.getElementById("product-lightbox");

/*
  The gallery can continue working without a lightbox, but lightbox
  initialization must not run when its container is absent.
*/
if (!lightboxEl) {
  return;
}

const lightboxSwiperEl = lightboxEl.querySelector(".lightbox-swiper");
const lightboxClose = lightboxEl.querySelector(".lightbox-close");
const lightboxCount = lightboxEl.querySelector(".lightbox-count");

if (!lightboxSwiperEl || !lightboxClose || !lightboxCount) {
  return;
}

let lightboxSwiper = null;

function getOriginVars() {
  // Get the main product image (currently active slide's img)
  const activeThumb = document.querySelector('.product-main-slider .swiper-slide-active img');
  if (!activeThumb) return null;

  const rect = activeThumb.getBoundingClientRect();
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  // Where the image currently sits vs viewport center
  const originCenterX = rect.left + rect.width / 2;
  const originCenterY = rect.top + rect.height / 2;

  const translateX = originCenterX - vw / 2;
  const translateY = originCenterY - vh / 2;

  // Scale factor: how small the origin image is compared to lightbox image
  const lightboxImgWidth = Math.min(vw * 0.85, 900); // approximate lightbox img width
  const scale = rect.width / lightboxImgWidth;

  return { translateX, translateY, scale };
}

function openLightbox(startIndex = 0) {
  const origin = getOriginVars();

  lightboxEl.classList.remove('hidden');
  lightboxEl.classList.add('is-open');
  document.body.style.overflow = 'hidden';

  if (!lightboxSwiper) {
    lightboxSwiper = new Swiper(lightboxSwiperEl, {
      initialSlide: startIndex,
      loop: false,
      keyboard: { enabled: true },
      on: {
        slideChange() {
          updateCount(this.activeIndex);
        }
      }
    });
  } else {
    lightboxSwiper.slideTo(startIndex, 0);
  }

  updateCount(startIndex);

  // Apply CSS vars and trigger animation
  if (origin) {
    lightboxSwiperEl.style.setProperty('--origin-x', `${origin.translateX}px`);
    lightboxSwiperEl.style.setProperty('--origin-y', `${origin.translateY}px`);
    lightboxSwiperEl.style.setProperty('--origin-scale', origin.scale);

    lightboxSwiperEl.classList.add('is-animating');
    setTimeout(() => lightboxSwiperEl.classList.remove('is-animating'), 400);
  }
}

function closeLightbox() {
  const origin = getOriginVars();

  if (origin) {
    lightboxSwiperEl.style.setProperty('--origin-x', `${origin.translateX}px`);
    lightboxSwiperEl.style.setProperty('--origin-y', `${origin.translateY}px`);
    lightboxSwiperEl.style.setProperty('--origin-scale', origin.scale);

    lightboxSwiperEl.classList.add('is-closing');

    setTimeout(() => {
      lightboxSwiperEl.classList.remove('is-closing');
      lightboxEl.classList.remove('is-open');
      lightboxEl.classList.add('hidden');
      document.body.style.overflow = '';
    }, 350);
  } else {
    lightboxEl.classList.remove('is-open');
    lightboxEl.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

  function updateCount(index) {
    const total = lightboxSwiper.slides.length;
    lightboxCount.textContent = `${index + 1} / ${total}`;
  }

  // Zoom button click → open at current main slider index
const productZoomButton = document.querySelector(".product-zoom-btn");

if (productZoomButton) {
  productZoomButton.addEventListener("click", function () {
    openLightbox(mainSwiper.activeIndex);
  });
}

  // Close via X button
  lightboxClose.addEventListener('click', closeLightbox);

  // Close via Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLightbox();
  });

  // Close via clicking the image area (zoom-out cursor behavior)
  lightboxSwiperEl.addEventListener('click', (e) => {
    // Only close if clicking directly on the slide/image, not nav arrows
    if (e.target.closest('.lightbox-nav')) return;
    closeLightbox();
  });

  document.getElementById('lightbox-prev').addEventListener('click', (e) => {
    e.stopPropagation(); // prevent lightbox close
    lightboxSwiper.slidePrev();
  });
  document.getElementById('lightbox-next').addEventListener('click', (e) => {
    e.stopPropagation();
    lightboxSwiper.slideNext();
  });

  const cursor = document.getElementById('lightbox-cursor');

  document.addEventListener('pointermove', (e) => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
  });

  lightboxSwiperEl.addEventListener('mouseenter', () => {
    cursor.style.opacity = '1';
  });

  lightboxSwiperEl.addEventListener('mouseleave', () => {
    cursor.style.opacity = '0';
  });

});


document.addEventListener("DOMContentLoaded", function() {

  // 🔥 Auto add IDs to headings based on text
  const headings = document.querySelectorAll("#articleContent h1, #articleContent h2, #articleContent h3, #articleContent h4, #articleContent h5, #articleContent h6");

  headings.forEach(heading => {
    if (!heading.id) {
      heading.id = heading.innerText
        .toLowerCase()
        .replace(/[^a-z0-9 ]/g, "")
        .replace(/\s+/g, "-");
    }
  });

  // Modal open
  const trigger = document.getElementById("tocTrigger");
  const modal = document.getElementById("tocModal");
  const overlay = document.getElementById("tocOverlay");
  const closeBtn = document.getElementById("tocCloseBtn");

  /*
    The article TOC does not exist on most storefront templates.
    Do not register its events unless the complete component exists.
  */
  if (!trigger || !modal || !overlay || !closeBtn) {
    return;
  }

  if (trigger) {
    trigger.addEventListener("click", () => {
      modal.classList.remove("opacity-0", "pointer-events-none");
    });
  }

  function closeModal() {
    modal.classList.add("opacity-0", "pointer-events-none");
  }

  overlay.addEventListener("click", closeModal);
  closeBtn.addEventListener("click", closeModal);

  // Close modal after TOC click (mobile)
  document.querySelectorAll(".toc-link").forEach(link => {
    link.addEventListener("click", () => {
      closeModal();
    });
  });

});




//Terms and Condition js logic
//--------------------------------------
document.addEventListener("DOMContentLoaded", function () {

  const tocLinks = document.querySelectorAll(".toc-link");
  const sections = document.querySelectorAll("[id^='section-'], #overview");

  if (!sections.length) return;

  function setActiveLink() {

    let currentId = "";

    sections.forEach(section => {
      const rect = section.getBoundingClientRect();

      if (rect.top <= 150) {
        currentId = section.id;
      }
    });

    tocLinks.forEach(link => {
      link.classList.remove("text-[#EA0029]", "font-bold!");

      if (link.getAttribute("href") === "#" + currentId) {
        link.classList.add("text-[#EA0029]", "font-bold");
      }
    });
  }

  window.addEventListener("scroll", setActiveLink);
  setActiveLink();

});

//OUR JOURNEY JS LOGIC
//-------------------------------
document.addEventListener("DOMContentLoaded", function() {

  const items = document.querySelectorAll(".timeline-item");
  const contents = document.querySelectorAll(".timeline-content");

  items.forEach(item => {

    item.addEventListener("click", function() {

      const index = this.getAttribute("data-index");

      // Remove active from all
      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".year-text").classList.remove("text-[#ea0029]");
        i.querySelector(".year-text").classList.add("text-[#7F7F7F]");
        i.querySelector(".title-text").classList.remove("text-[#1D1D1F]");
        i.querySelector(".title-text").classList.add("text-[#7F7F7F]");
      });

      // Hide all content
      contents.forEach(c => c.classList.add("hidden"));

      // Activate clicked
      this.classList.add("active");
      this.querySelector(".year-text").classList.remove("text-[#7F7F7F]");
      this.querySelector(".year-text").classList.add("text-[#ea0029]");
      this.querySelector(".title-text").classList.remove("text-[#7F7F7F]");
      this.querySelector(".title-text").classList.add("text-[#1D1D1F]");

      // Show matching content
      document.querySelector('.timeline-content[data-index="' + index + '"]').classList.remove("hidden");

    });

  });

});


// Mobile Menu Multi-level Logic
// ---------------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.getElementById("mobileMenuTrigger");
  const overlay = document.getElementById("mobileMenuOverlay");
  const panel = document.getElementById("mobileMenuPanel");
  const closeBtn = document.getElementById("mobileMenuClose");
  const track = document.getElementById("mobileMenuTrack");

  if (!trigger || !panel || !overlay) {
    console.warn("Mobile menu elements not found");
    return;
  }

  const openMenu = () => {
    // Show Overlay
    overlay.classList.remove("hidden", "opacity-0", "pointer-events-none");
    overlay.classList.add("opacity-100", "pointer-events-auto", "visible");
    
    // Show Panel - Pop in center
    panel.classList.remove("hidden", "opacity-0", "scale-95", "pointer-events-none");
    panel.classList.add("opacity-100", "scale-100", "pointer-events-auto", "open");
    
    document.body.classList.add("overflow-hidden");
    trigger.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => {
      closeBtn?.focus();
    });
  };

  const closeMenu = () => {
    // Hide Overlay
    overlay.classList.remove("opacity-100", "pointer-events-auto", "visible");
    overlay.classList.add("opacity-0", "pointer-events-none");
    
    // Hide Panel - Pop out
    panel.classList.remove("opacity-100", "scale-100", "pointer-events-auto", "open");
    panel.classList.add("opacity-0", "scale-95", "pointer-events-none");
    
    document.body.classList.remove("overflow-hidden");
    trigger.setAttribute("aria-expanded", "false");
    panel.setAttribute("aria-hidden", "true");
    trigger.focus();

    // Reset position after closure animation
    setTimeout(() => {
      overlay.classList.add("hidden");
      panel.classList.add("hidden");
      if (track) {
        track.style.transform = "translateX(0)";
        document.querySelectorAll(".mobile-sub-detail").forEach(s => s.classList.remove("active"));
      }
    }, 300);
  };

  trigger.onclick = (e) => {
    e.preventDefault();
    openMenu();
  };

  if (closeBtn) closeBtn.onclick = closeMenu;
  overlay.onclick = closeMenu;
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && panel.classList.contains("open")) {
      closeMenu();
    }
  });

  // Global functions for menu navigation
  window.moveMenu = (level) => {
    if (track) {
      track.style.transform = `translateX(-${level * 100}%)`;
    }
  };

  window.openSubLevel = (index) => {
    const allSubs = document.querySelectorAll(".mobile-sub-detail");
    allSubs.forEach(s => s.classList.remove("active"));

    const target = document.getElementById(`sub-${index}`);
    if (target) {
      target.classList.add("active");
      moveMenu(2);
    }
  };
});

/**
 * AJAX CART SUCCESS POPUP - UI UPDATE
 */
function openCartPopup(item) {
  const popup = document.getElementById('cartPopup');
  const popupImage = document.getElementById('cartPopupImage');
  const popupTitle = document.getElementById('cartPopupTitle');

  if (!popup) return;

  // Set product info
  if (popupImage instanceof HTMLImageElement) {
    popupImage.src = item.image || '';
  }
  if (popupTitle) {
    popupTitle.textContent = item.product_title || item.title || '';
  }

  // Show popup
  popup.classList.add('visible');
  document.body.classList.add('overflow-hidden');
}

/**
 * REFRESH HEADER CART COUNT
 */
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const countBubbles = document.querySelectorAll('.cart-count-bubble');
    countBubbles.forEach(bubble => {
      bubble.textContent = cart.item_count;
      if (cart.item_count > 0) {
        bubble.classList.remove('hidden');
      } else {
        bubble.classList.add('hidden');
      }
    });
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

/**
 * UNIFIED AJAX CART HANDLERS
 */
document.addEventListener('DOMContentLoaded', () => {
  const cartPopup = document.getElementById('cartPopup');
  const closeBtn = document.getElementById('cartPopupClose');
  const continueBtn = document.getElementById('continueShopping');

  // Close popup helper
  const closePopup = () => {
    if (cartPopup) {
      cartPopup.classList.remove('visible');
      document.body.classList.remove('overflow-hidden');
    }
  };

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (continueBtn) continueBtn.addEventListener('click', closePopup);
  if (cartPopup) {
    cartPopup.addEventListener('click', (e) => {
      if (e.target === cartPopup) closePopup();
    });
  }

  /* 
  // Handle all AJAX forms (Delegation) - DISABLED to prevent double-adding (Conflict with cart-drawer.js / product-custom.liquid)
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('ajax-add-to-cart')) return;

    e.preventDefault();
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
      submitButton.classList.add('opacity-50');
    }

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Add to cart failed');
      const item = await response.json();
      
      openCartPopup(item);
      updateCartCount();

    } catch (err) {
      console.error('AJAX Error:', err);
    } finally {
      if (submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = false;
        submitButton.classList.remove('opacity-50');
      }
    }
  });
  */

  // Handle "Trending Socials" Buttons specifically (old)
  // document.addEventListener('click', async (e) => {
  //   const btn = e.target;
  //   if (!(btn instanceof HTMLElement)) return;
  //   const addToCartBtn = btn.closest('#popupAddToCart');
  //   if (!addToCartBtn) return;

  //   const variantId = addToCartBtn.getAttribute('data-variant-id');
  //   if (!variantId) return;

  //   if (addToCartBtn instanceof HTMLButtonElement) {
  //      addToCartBtn.disabled = true;
  //      addToCartBtn.innerHTML = '<span class="animate-pulse">Adding...</span>';
  //   }

  //   try {
  //     const response = await fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'X-Requested-With': 'XMLHttpRequest'
  //       },
  //       body: JSON.stringify({ id: variantId, quantity: 1 })
  //     });

  //     if (!response.ok) throw new Error('Add to cart failed');
  //     const item = await response.json();
      
  //     openCartPopup(item);
  //     updateCartCount();
  //   } catch (err) {
  //     console.error('AJAX Error:', err);
  //   } finally {
  //      if (addToCartBtn instanceof HTMLButtonElement) {
  //        addToCartBtn.disabled = false;
  //        addToCartBtn.textContent = 'Add to cart';
  //      }
  //   }
  // });

  // Handle "Trending Socials" Buttons specifically (new)
  document.addEventListener('click', async (e) => {
  const btn = e.target;
  if (!(btn instanceof HTMLElement)) return;

  const addToCartBtn = btn.closest('.popupAddToCart');
  if (!addToCartBtn) return;

  const variantId = addToCartBtn.getAttribute('data-variant-id');
  if (!variantId) return;

  // UI loading state
  if (addToCartBtn instanceof HTMLButtonElement) {
    addToCartBtn.disabled = true;
    addToCartBtn.innerHTML = '<span class="animate-pulse">Adding...</span>';
  }

  try {
    // 🟢 Add to cart
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');

    const item = await response.json();

    // 🟢 Fetch updated cart (THIS is key)
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    // 🟢 Update ALL cart badges
    updateCartUI(cart);

    // 🟢 Optional popup
    openCartPopup(item);

  } catch (err) {
    console.error('AJAX Error:', err);
  } finally {
    if (addToCartBtn instanceof HTMLButtonElement) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = 'Add to cart';
    }
  }
});

function updateCartUI(cart) {
  const count = cart.item_count;

  // Header badge
  const headerBadge = document.querySelector('.cart-count-bubble');
  if (headerBadge) {
    headerBadge.innerText = count;
    headerBadge.classList.toggle('hidden', count === 0);
  }

  // Popup badge (can be multiple)
  const popupBadges = document.querySelectorAll('.popupCartCount');
  popupBadges.forEach(badge => {
    badge.innerText = count;
    badge.classList.toggle('hidden', count === 0);

    // 🔥 micro animation
    badge.classList.add('scale-125');
    setTimeout(() => badge.classList.remove('scale-125'), 200);
  });
}
});

     
              // document.addEventListener('DOMContentLoaded', function () {
              //   var currentOfferIndex = 0;
              //   var offerCards = document.querySelectorAll('.offer-card');
              //   var progressFills = document.querySelectorAll('.offer-progress-fill');

              //   window.advanceOffers = function () {
              //     if (offerCards.length <= 1) return;

              //     // Hide current
              //     offerCards[currentOfferIndex].classList.add('hidden');
              //     progressFills[currentOfferIndex].classList.remove('w-full');
              //     progressFills[currentOfferIndex].classList.add('w-0');

              //     // Move to next
              //     currentOfferIndex = (currentOfferIndex + 1) % offerCards.length;

              //     // Show next
              //     offerCards[currentOfferIndex].classList.remove('hidden');
              //     progressFills[currentOfferIndex].classList.remove('w-0');
              //     progressFills[currentOfferIndex].classList.add('w-full');
              //   };

              //   if (offerCards.length > 1) {
              //     setInterval(window.advanceOffers, 4000);
              //   }
              // });
          


